import { FormControl, InputLabel } from "@mui/material"
import type { FC } from "react"
import { useFormContext } from "react-hook-form"

import { INVOICE_DOCUMENT_TYPE_OPTIONS } from "../../constants"
import type { InvoiceFormValues } from "../../schemas/invoiceForm"

import { InvoiceFormDocumentsPane } from "./InvoiceFormDocumentsPane"

import { DOCUMENT_UPLOAD_MIME_TYPES, DOCUMENT_UPLOAD_TYPES_LABEL } from "@/components/upload/constants"
import { MultiFileUpload } from "@/components/upload/MultiFileUpload/MultiFileUpload"
import type { UploadRowStatus } from "@/components/upload/MultiFileUpload/types"
import type { UploadRowProgress } from "@/hooks/useMultiFileUpload"

interface InvoiceAttachmentsSectionProps {
  invoiceId?: string
  disabled?: boolean
  statuses?: Record<string, UploadRowStatus>
  progress?: Record<string, UploadRowProgress>
  isUploading?: boolean
}

export const InvoiceAttachmentsSection: FC<InvoiceAttachmentsSectionProps> = ({
  disabled,
  invoiceId,
  statuses,
  progress,
  isUploading,
}) => {
  const { control } = useFormContext<InvoiceFormValues>()

  return (
    <FormControl required className='flex flex-col gap-3'>
      <InputLabel shrink>Attachments</InputLabel>

      {invoiceId && <InvoiceFormDocumentsPane invoiceId={invoiceId} disabled={disabled} />}

      <MultiFileUpload
        control={control}
        name='attachments'
        documentTypeOptions={INVOICE_DOCUMENT_TYPE_OPTIONS}
        allowedMimeTypes={DOCUMENT_UPLOAD_MIME_TYPES}
        allowedTypesLabel={DOCUMENT_UPLOAD_TYPES_LABEL}
        statuses={statuses}
        progress={progress}
        isUploading={isUploading}
        readOnly={disabled}
        testIdPrefix='invoice.attachments.multi-file-upload'
      />
    </FormControl>
  )
}
